export function flatten(list) {
  return list.reduce(
    (a, b) => a.concat(Array.isArray(b) ? flatten(b) : b), [],
  );
}

export function actionIs(name) {
  return ({ action }) => name === action;
}

export function toGetParams(obj) {
  const q = [];
  Object.keys(obj)
    .map((k) => [k, obj[k]])
    .filter((item) => item[1] !== null && item[1] !== '' && typeof item[1] !== 'undefined')
    .map(([k, v]) => {
      if (Array.isArray(v)) {
        Array.from(v)
          .filter((i) => (i !== null && i !== '' && typeof i !== 'undefined'))
          .map((i) => {
            q.push(`${encodeURIComponent(k)}=${encodeURIComponent(i)}`);
            return true;
          });
      } else {
        q.push(`${encodeURIComponent(k)}=${encodeURIComponent(v)}`);
      }
      return true;
    });
  const getParams = q.join('&');

  return getParams ? `?${getParams}` : '';
}

export function decodeHTML(escapedHtml) {
  const escapeEl = document.createElement('textarea');
  escapeEl.innerHTML = escapedHtml;
  return escapeEl.textContent;
}

export function svgContent(name) {
   
  return { __html: `<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="${SPRITE_URL}${name}"></use>` };
}

export function addGetParameters(urlString, params) {
  const url = new URL(urlString, document.location.href);
  const searchParams = new URLSearchParams(url.search);
  params.forEach((param) => {
    searchParams.append(param.name, param.value);
  });
  url.search = searchParams.toString();
  document.location.href = url.href;
}
export function createForm(url, params) {
  // create and return new form from gave url and params.
  // it's needing because for send request to wfp using method POST and
  // reloading to payment page

  const wfpForm = document.createElement('form');
  const button = document.createElement('button', { type: 'submit' });

  wfpForm.action = url;
  wfpForm.method = 'POST';
  wfpForm.style.visibility = 'hidden';
  wfpForm.appendChild(button);

  Object.entries(params).map(([key, value]) => {
    const input = document.createElement('input');

    input.name = key;
    input.value = value;

    wfpForm.appendChild(input);
    return true;
  });

  document.body.appendChild(wfpForm);
  return wfpForm;
}

export function generateContentCategory(breadcrumbs) {
  const contentCategory = [];
  breadcrumbs.forEach((item) => {
    if (item.id) {
      contentCategory.push(item.title);
    }
  });
  return contentCategory;
}

export function findNode(tree, categoryId) {
  return tree.children.find((x) => x.id === categoryId);
}

export function HiddenFilterBlock() {
  const filterBlock = document.querySelector('.b-filter__container');
  filterBlock.classList.add('hidden');
  const filterState = document.querySelector('#filters');
  filterState.classList.remove('b-filter_state_active');
}

export const randomString = (length) => {
  const result = [];
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i += 1) {
    result.push(characters.charAt(Math.floor(Math.random()
            * charactersLength)));
  }
  return result.join('');
};
